import FirstAppointment from './FirstAppointment.view';

export default FirstAppointment;
